module.exports = __webpack_public_path__ + "static/qrcode-29_12_21-1304fdc03529d8a20fafe75d6f06651f.png";